import { type CommonAction, response } from "@iflyrpa/share";
import { z } from "zod";
import type { ActiomCommonParams, AxiosProxyParams } from "../../types";
import { Http } from "../../utils/http";
import { Xhshow } from "../../utils/xhsXsEncrypt";

// 小红书参数加密器
const xsEncrypt = new Xhshow();

export interface CollectionResponse {
    success: boolean;
    result: number;
    data: {
        has_more: boolean;
        collection_info_list: CollectionDetail[];
    };
}

export const CollectionDetailSchema = z.object({
    id: z.string(),
    name: z.string(),
    icon: z.string(),
    note_num: z.number(),
    view_num: z.number(),
    paid: z.number(),
    type: z.number(),
    collected: z.boolean(),
    desc: z.string(),
    total_episodes: z.number(),
    create_time: z.number(),
});

export type CollectionDetail = z.infer<typeof CollectionDetailSchema>;

export type PublishAction = CommonAction<ActiomCommonParams, CollectionDetail[]>;

export const getXhsCollection: PublishAction = async (_task, params) => {
    const headers = {
        cookie: params.cookies.map((it) => `${it.name}=${it.value}`).join(";"),
        referer: "https://creator.xiaohongshu.com",
        origin: "https://creator.xiaohongshu.com",
    };

    const args: AxiosProxyParams = [{ headers }, _task.logger, params.proxyLoc, params.accountId];

    const http = new Http(...args);

    const a1Cookie = params.cookies.find((it) => it.name === "a1")?.value;
    if (!a1Cookie) return { code: 414, message: "账号数据异常，请重新绑定账号后重试。", data: [] };
    const fatchCollextion = "/api/sns/v1/note/collection/pc/list_v2";
    const recordCookie = params.cookies.reduce<Record<string, string>>((acc, cookie) => {
        if (cookie.name && cookie.value) {
            acc[cookie.name] = cookie.value;
        }
        return acc;
    }, {});
    const colletionData = { cursor: "", need_type_list: [0], target_uid: "" };
    const collectionXsHeader = xsEncrypt.signHeadersPost(fatchCollextion, recordCookie, "xhs-pc-web", colletionData);

    const res = await http.api<CollectionResponse>(
        {
            method: "POST",
            url: "https://edith.xiaohongshu.com/api/sns/v1/note/collection/pc/list_v2",
            data: colletionData,
            headers: collectionXsHeader,
        },
        { retries: 3, retryDelay: 20, timeout: 3000 },
    );

    const isSuccess = res.result === 0;
    const message = `合集信息获取${isSuccess ? "成功!" : "失败!"}${_task.debug ? ` ${http.proxyInfo}` : ""}`;
    const data = isSuccess ? res.data.collection_info_list : [];

    return response(isSuccess ? 0 : 414, message, data);
};
